import { PRODUCTION, DEVELOPMENT, SANCTIONS_DEV_URL } from "./const";
import { isEmpty } from "lodash";

export function RpsApiUrl() {
  const REACT_ENV = process.env.NODE_ENV;
  const API_URL = !!process.env.REACT_APP_SANCTIONS_URL && process.env.REACT_APP_SANCTIONS_URL !== "" ? process.env.REACT_APP_SANCTIONS_URL : "";
  if (!isEmpty(REACT_ENV)) {
    switch (REACT_ENV) {
      case DEVELOPMENT:
        return SANCTIONS_DEV_URL;
      case PRODUCTION:
        return API_URL;
      default:
        return SANCTIONS_DEV_URL;
    }
  } else {
    return SANCTIONS_DEV_URL;
  }
}

export const getRpsApiUrl = (path) => {
  return `${RpsApiUrl()}${path}`;
};
